import Dropdown from "rc-dropdown";
import "rc-dropdown/assets/index.css";
import Menu from "rc-menu";
import "rc-menu/assets/index.css";
import React from "react";
import { generatePath } from "react-router-dom";
import Button from "../../../../../components/form/Button";
import { ROUTE_TEMPLATES_EDIT } from "../../../../../constants/routes";
import { Destination } from "../../../../../models";

export const DestinationTemplatesColumn = ({
  destination,
}: {
  destination: Destination;
}) => {
  if (
    !destination["template_list"] ||
    destination["template_list"]?.length === 0
  ) {
    return <div className="md:text-center">-</div>;
  }

  return (
    <div className="md:text-center">
      <Dropdown
        overlay={
          <Menu
            onClick={(e) => {
              e.domEvent.stopPropagation();
              window.open(
                generatePath(ROUTE_TEMPLATES_EDIT, { id: e.key }) +
                  "?redirect_to_step=destination",
                "_blank"
              );
            }}
            className="text-sm max-h-96 overflow-y-scroll no-scrollbar"
            selectable={false}
            style={{ padding: 4, minWidth: 250 }}
            prefixCls="rc-menu"
          >
            {destination["template_list"].map((option) => {
              return (
                <Menu.Item
                  key={option.template_id}
                  className="hover:bg-gray-0 hover:text-primary flex gap-1 items-center justify-between"
                  style={{ padding: "6px 8px", cursor: "pointer" }}
                >
                  <div className="flex gap-1 min-w-0">
                    <span className="truncate">{option.template_name}</span>
                  </div>
                </Menu.Item>
              );
            })}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button
          paddingZero
          variant="light-primary"
          className="p-0.5 w-8"
          onClick={(e: any) => {
            e.stopPropagation();
          }}
        >
          {destination["template_list"]?.length}
        </Button>
      </Dropdown>
    </div>
  );
};
